import { SxProps, Theme } from '@mui/material';
import { Colors } from '../../../constants';

export const systemHeaderStyles: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	height: '66px',
	gap: '10px',
	backgroundColor: Colors.black,
	borderBottom: `1px solid ${Colors['1E1E1E']}`,

	'& >div': {
		display: 'flex',
		alignItems: 'center',
		height: '100%',
	},
};

export const launchEventButtonStyles: SxProps<Theme> = {
	p: '12px 32px',
	width: { xs: '130px', md: '230px' },
	fontFamily: 'Integral CF, sans-serif',
	fontWeight: 600,
	fontSize: '13px',
	lineHeight: '100%',
};

export const ticketsButtonStyles: SxProps<Theme> = {
	p: '9px',
	backgroundColor: Colors.white_a10,
	borderRadius: '8px',

	'&.Mui-disabled': {
		opacity: 1,
	}
};

export const userMenuButtonStyles: SxProps<Theme> = {
	p: '2px 6px 2px 4px',
	columnGap: '3px',
	backgroundColor: Colors.white_a10,
	borderRadius: '36px',
};

export const searchInputStyles: SxProps<Theme> = {
	backgroundColor: Colors['101010'],
	borderRadius: '50px',
	width: '100%',

	transition: theme => theme.transitions.create(['background-color', 'color', 'border-color'], {
		duration: theme.transitions.duration.short
	}),

	'& .MuiOutlinedInput-notchedOutline': {
		borderColor: Colors['E9E9E9_a10'],
		transition: theme => theme.transitions.create('border-color', {
			duration: theme.transitions.duration.short
		}),
	},
	'&:hover': {
		backgroundColor: Colors['1E1E1E'],

		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: Colors.white_a20,
		},
	},
	'&.Mui-focused': {
		backgroundColor: Colors['1E1E1E'],

		'& .MuiOutlinedInput-notchedOutline': {
			borderWidth: '1px',
			borderColor: Colors.white_a30,
		},
	},
	'& .MuiOutlinedInput-input': {
		flex: 1,
		height: '24px',
		padding: '6px 12px 6px 12px',
		fontSize: '14px',
		fontFamily: 'Montserrat, sans-serif',
		fontWeight: 500,
		lineHeight: '1.2em',
		color: Colors.white,

		'&::placeholder': {
			fontSize: '14px',
			fontFamily: 'Montserrat, sans-serif',
			fontWeight: 500,
			lineHeight: '1.2em',
			color: Colors.white_a50,
		},
	},
	'&.MuiInputBase-adornedStart': {
		paddingLeft: '12px',
	},
	"& >svg": {
		width: '20px',
		height: '20px',
		color: Colors.white_a50,
	},
};
